import script from "./serving-size-browse.vue?vue&type=script&setup=true&lang=js"
export * from "./serving-size-browse.vue?vue&type=script&setup=true&lang=js"

import "./serving-size-browse.vue?vue&type=style&index=0&id=813889b2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-813889b2"]])

export default __exports__